import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import UploadDocIcon from "../../../../../../../media/images/icons/upload-doc";

interface Props {
  title: string;
}

export default function UploadButton({ title }: Props) {
  const theme = useTheme();
  return (
    <Box
      sx={{
        paddingY: "8px",
        borderRadius: "8px",
        borderWidth: "1px",
        borderColor: "secondary.main",
        borderStyle: "dashed",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
      }}
    >
      <UploadDocIcon color={theme.palette.secondary.main} />
      <Typography
        sx={{
          color: "secondary.main",
        }}
      >
        {title}
      </Typography>
    </Box>
  );
}
